import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import { moreFilterOptions } from '../configuration/filtering'
import { useFilterTours } from './useFilterTours'
import { useSearchResults } from './useSearchResults'
import { getDestinationsData } from '../redux/reducers/destinations'
import { getFilters } from '../redux/reducers/filters'
import { getFilterSetFromTourResults } from '../utilities/content/content'

export function useGetMoreFilterContentFromResults(filterKey) {
  const destinations = useSelector(getDestinationsData)
  const filters = useSelector(getFilters)
  const searchResults = useSearchResults()

  const otherFilters = _.omit(filters, moreFilterOptions)

  const filteredTours = useFilterTours(searchResults, otherFilters)

  return useMemo(() => {
    return getFilterSetFromTourResults(destinations, filterKey, filteredTours)
  }, [destinations, filterKey, filteredTours])
}
